
<script>
import vue2Dropzone from "vue2-dropzone";
import { categoryService } from "../../services";
import { required } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message } from "../../Helper/helper";
import { success_message } from "../../Helper/helper";
import DropzoneSingle from "../../components/widgets/dropzone-single";
import DropzonePopup from "../../components/widgets/dropzone-popup";

export default {
  components: { vueDropzone: vue2Dropzone, DropzoneSingle, DropzonePopup },
  data() {
    return {
      checked: true,
      file1: null,
      tmpCategoryImage: "",
      url: null,
      attrName :{},
      attrValue :{},
      config: config,
      attr_id: "",
      isDisabled:false,
      typeform: {
        category_name: "",
        category_name_thai: "",
        category_desc: "",
        category_desc_thai: "",
        color_code: "#f2f3f4",
        text_color_code: "#000000",
        status: 1,
        category_img: null,
        navigation_image: null,
        is_coupon_applicable: 1,
        is_pickup_dis_applicable: 1,
        is_subs_discount_applicable: 0
      },
    };
  },
  validations: {
    typeform: {
      category_name: {
        required,
      },
      category_name_thai: {
        required
      },
      category_desc: {
        required,
      },
      category_desc_thai: {
        required
      },
      category_img: {
        required,
      },
      navigation_image: {
        required,
      }
    }
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
      this.typeform.category_img = file;
    },
    categoryInIt() {
      this.$v.$touch();
      if (this.$v.typeform.$invalid) {
        setTimeout(()=>{
            $('html, body').animate({
                scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
            }, 100, function() {
                $(".is-invalid:first").focus();
            });
        },200);
        return;
      } else {
        this.isDisabled = true;
        categoryService.addCategory(this.typeform).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "category-list" });
          } else {
            error_message(response.data.message);
          }
          this.isDisabled = false;
        });
      }
    },
    // getAttribute(){
    //   categoryService.getAttribute().then((response) => {
    //     this.attrName = response.data.result;
    //   });
    // },
    contactNumber(evt) {
      let val1 = evt.target.value;
      if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
          evt.preventDefault();
      }
      let partlen = val1.split("+").length - 1;
      if (evt.keyCode == 43 && partlen > 0) {
          evt.preventDefault();
      } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
          evt.preventDefault();
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="categoryInIt">
    <!-- Category Info Start -->
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{ trans.get('__JSON__.Category Info') }}</h4>
        <p class="card-title-desc"></p>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group" v-if="$auth.setting">
              <label class="required">{{ trans.trans('__JSON__.Category Name Language',{ lang: $auth.langauges[0].name }) }}</label>
              <input
                id="category_name"
                v-model="$v.typeform.category_name.$model"
                type="text"
                class="form-control"
                :placeholder="trans.trans('__JSON__.Category Name Language',{lang: $auth.langauges[0].name})"
                name="category_name"
                :class="{ 'is-invalid': $v.typeform.category_name.$error }"
              />
              <div v-if="$v.typeform.category_name.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.category_name.required">{{ trans.get('__JSON__.Please Enter category Name Error') }}</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6" v-if="$auth.langauges[1].name != 'No Secondary Language'">
            <div class="form-group">
                <label class="required">{{ trans.trans('__JSON__.Category Name Language',{lang: $auth.langauges[1].name }) }}</label>
                <input
                  id="category_name_thai"
                  name="category_name_thai"
                  type="text"
                  v-model="$v.typeform.category_name_thai.$model"
                  :placeholder="trans.trans('__JSON__.Category Name Language',{lang: $auth.langauges[1].name })"
                  class="form-control"
                   :class="{ 'is-invalid': $v.typeform.category_name_thai.$error }"
                />
                <div v-if="$v.typeform.category_name_thai.$error" class="invalid-feedback">
                <span v-if="!$v.typeform.category_name_thai.required">{{ trans.get('__JSON__.Please Enter category Name Error') }}</span>
              </div>
               </div>
          </div>

          <div class="col-sm-6">
              <div class="form-group" v-if="$auth.setting">
                <label class="required">{{ trans.trans('__JSON__.Category Description Language',{lang: $auth.langauges[0].name }) }}</label>
                <input
                  rows="5"
                  id="category_desc"
                  name="category_desc"
                  type="text"
                  v-model="$v.typeform.category_desc.$model"
                  :placeholder="trans.trans('__JSON__.Category Description Language',{lang: $auth.langauges[0].name })"
                  class="form-control"
                  :class="{ 'is-invalid': $v.typeform.category_desc.$error }"
                />
                <div v-if="$v.typeform.category_desc.$error" class="invalid-feedback">
                <span
                  v-if="!$v.typeform.category_desc.required"
                >{{ trans.get('__JSON__.Please Enter Category Description Error') }}.</span>
              </div>
            </div>
          </div>

          <div class="col-sm-6" v-if="$auth.langauges[1].name != 'No Secondary Language'">
            <div class="form-group">
                <label class="required">{{ trans.trans('__JSON__.Category Description Language',{lang: $auth.langauges[1].name }) }}</label>
                <input
                  rows="5"
                  id="category_desc_thai"
                  name="category_desc_thai"
                  type="text"
                  v-model="typeform.category_desc_thai"
                  :placeholder="trans.trans('__JSON__.Category Description Language',{lang: $auth.langauges[1].name })"
                  class="form-control"
                  :class="{ 'is-invalid': $v.typeform.category_desc_thai.$error }"
                />
                <div v-if="$v.typeform.category_desc_thai.$error" class="invalid-feedback">
                <span
                  v-if="!$v.typeform.category_desc_thai.required"
                >{{ trans.get('__JSON__.Please Enter Category Description Error') }}.</span>
              </div>
               </div>
          </div>

          <div class="col-md-6 vendor-status">
            <b-form-group
              id="input-group-2"
              :label="trans.get('__JSON__.Status')"
              label-for="Status"
            >
              <div class="row">
                <div class="col-sm-6">
                  <div class="swtich-data">
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        class="switch-on"
                        name="status"
                        v-model="typeform.status"
                        true-value="1"
                        false-value="0"
                      />
                      <div class="slider round">
                        <!--ADDED HTML -->
                        <span class="on">{{ trans.get('__JSON__.Active') }}</span>
                        <span class="off">{{ trans.get('__JSON__.Inactive') }}</span>
                        <!--END-->
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-6 vendor-status">
            <b-form-group
              id="input-group-2"
              :label="trans.get('__JSON__.Coupon Applicable')"
              label-for="is_coupon_applicable"
            >
              <div class="row">
                <div class="col-sm-6">
                  <div class="swtich-data">
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        class="switch-on"
                        name="is_coupon_applicable"
                        v-model="typeform.is_coupon_applicable"
                        true-value="1"
                        false-value="0"
                      />
                      <div class="slider round">
                        <!--ADDED HTML -->
                        <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                        <span class="off">{{ trans.get('__JSON__.No') }}</span>
                        <!--END-->
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>

          <div class="col-md-6 vendor-status">
            <b-form-group
              id="input-group-2"
              :label="trans.get('__JSON__.Pickup Discount Applicable')"
              label-for="is_pickup_dis_applicable"
            >
              <div class="row">
                <div class="col-sm-6">
                  <div class="swtich-data">
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        class="switch-on"
                        name="is_pickup_dis_applicable"
                        v-model="typeform.is_pickup_dis_applicable"
                        true-value="1"
                        false-value="0"
                      />
                      <div class="slider round">
                        <!--ADDED HTML -->
                        <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                        <span class="off">{{ trans.get('__JSON__.No') }}</span>
                        <!--END-->
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div>

          <!-- <div class="col-md-6 vendor-status">
            <b-form-group
              id="input-group-2"
              :label="trans.get('__JSON__.Subscription Discount Applicable')"
              label-for="is_subs_discount_applicable"
            >
              <div class="row">
                <div class="col-sm-6">
                  <div class="swtich-data">
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        class="switch-on"
                        name="is_subs_discount_applicable"
                        v-model="typeform.is_subs_discount_applicable"
                        true-value="1"
                        false-value="0"
                      />
                      <div class="slider round">
                        <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                        <span class="off">{{ trans.get('__JSON__.No') }}</span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </b-form-group>
          </div> -->

          <div class="col-md-6">
            <div class="row">
              <div class="col-sm-6">
                <b-form-group
                  id="input-group-2"
                  :label="trans.get('__JSON__.Menu Color Code')"
                  label-for="Menu Color Code"
                ></b-form-group>
                 <input
                  type="color"
                  id="colorpickers1"
                  v-model="typeform.color_code"
                  name="color_code"
                  pattern="^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$"
                  value="#f2f3f4"
                />
              </div>
              <div class="col-sm-6">
                <b-form-group
                  id="input-group-2"
                  :label="trans.get('__JSON__.Text Color Code')"
                  label-for="Text Color Code"
                ></b-form-group>
                  <input
                  type="color"
                  id="colorpickers1"
                  v-model="typeform.text_color_code"
                  name="text_color_code"
                  pattern="^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$"
                  value="#000000"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Category Info End -->

    <!-- Attributes Start -->
    <!-- <div class="card">
      <div class="card-body">
        <h4 class="card-title required">{{ trans.get('__JSON__.Category Attributes') }}</h4>
        <p class="card-title-desc"></p>

        <div class="row" v-for="(v,i) in Object.keys(attrName)" :key="i">
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ v }}</label>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group cust-checkbox">
              <template v-for="item in attrName[v]">
                <input type="checkbox" :id="item.att_name" :value="item" :key="item.att_name" v-model="typeform.attributes">
                <label :for="item.att_name" :key="item.att_name +'_name'">{{ item.att_name }}</label>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Attributes End -->

    <!-- Category Image Start -->
    <div class="card">
      <div class="card-body">
        

        <div class="row">
          <div class="col-sm-6">
            <h4 class="card-title required">{{ trans.get('__JSON__.Category Image') }}</h4>
            <p class="card-title-desc"></p>
            <dropzone-popup
              v-model="$v.typeform.category_img.$model"
              type="file"
              id="category_img"
              name="image"
              acceptedFiles=".jpeg,.jpg,.png"
            />
            <div v-if="$v.typeform.category_img.$error" class="invalid-feedback cuisine-img">
              <span
                v-if="!$v.typeform.category_img.required"
              >{{ trans.get('__JSON__.Please Select Category Image Error') }}.</span>
            </div>
          </div>

          <div class="col-sm-6">
            <h4 class="card-title required">{{ trans.get('__JSON__.Category Image For Navigation') }}</h4>
            <p class="card-title-desc"></p>
            <dropzone-popup
              v-model="$v.typeform.navigation_image.$model"
              type="file"
              id="navigation_image"
              name="image"
              acceptedFiles=".jpeg,.jpg,.png"
            />
            <div v-if="$v.typeform.navigation_image.$error" class="invalid-feedback cuisine-img">
              <span
                v-if="!$v.typeform.navigation_image.required"
              >{{ trans.get('__JSON__.Please select navigation image') }}.</span>
            </div>
          </div>
        </div>
        
        <!-- Category Image End -->

        <div class="row">
          <div class="col-sm-6">
            <button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">{{ trans.get('__JSON__.Add Category') }}</button>
            <!-- <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button> -->
            <router-link
              :to="{name:'category-list'}"
            >
              <b-button
                type="button" 
                variant="secondary" 
                class="mt-3">
                {{ trans.get('__JSON__.Cancel') }}
              </b-button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    
  </form>
</template>